import { render } from "./historyMainPage.vue?vue&type=template&id=01b730e5&scoped=true"
import script from "./historyMainPage.vue?vue&type=script&lang=js"
export * from "./historyMainPage.vue?vue&type=script&lang=js"

import "./historyMainPage.vue?vue&type=style&index=0&id=01b730e5&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b730e5"]])

export default __exports__